export const contactsData = {
    email: 'sameedhussain.work@gmail.com',
    address: 'Karachi, Pakistan',
    sheetAPI: 'https://formspree.io/f/myzprjqk'
}